import { FC } from 'react';

import { DataLink } from 'components/Shared/SharedComponents';
import Tick from 'src/shared/ui/Tick/Tick';

import styles from '../styles.module.scss';
import type { IGreetingChild } from '../../config/declarations';

const YourOffers: FC<IGreetingChild> = ({ link }) => {
  if (!link) {
    return null;
  }

  return (
    <DataLink link={link} className={styles.offerLink}>
      {link.title}
      <Tick
        color="#f18536"
        borderWidth={3}
        direction="right"
        className={styles.tick}
      />
    </DataLink>
  );
};

export default YourOffers;
